import React, { useState, useEffect } from "react";
import { Button, Modal, Form } from "react-bootstrap";
import axios from "axios";
import icons from "../../iconsList.json";
// DİKKAT: Drag & Drop için hello-pangea/dnd
import { DragDropContext, Droppable, Draggable } from "@hello-pangea/dnd";
import useTranslations from "../../hooks/useTranslations";
import useUserLanguage from "../../hooks/useUserLanguage";

// Yardımcı fonksiyon: Liste sırasını yeniden düzenlemek
const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);
  return result;
};

const ModuleCreate = () => {
  
  // Form state
  const [formData, setFormData] = useState({
    name: "",
    icon: "",
    single_name: "",
    single_slug: "",
    multiple_name: "",
    multiple_slug: "",
    elements: [],
    showTable: false,
    hasCategory: false,
    categoryType: "none", 
  });

  const language = useUserLanguage();
  const { translations } = useTranslations(language);
  const getText = (key, defaultValue) => translations[key] || defaultValue;

  const [loading, setLoading] = useState(false);

  // Modal kontrolleri
  const [showElementModal, setShowElementModal] = useState(false);
  const [showIconModal, setShowIconModal] = useState(false);

  // Yeni element state'i (modal içinde)
  const [newElement, setNewElement] = useState({
    type: "text",
    name: "",
    label: "",
    placeholder: "",
    required: false,
    table: false,
    maxWidth: "",
    maxHeight: "",
    content_values: "",
    content_titles: ""
  });

  // İkon arama
  const [iconSearch, setIconSearch] = useState("");
  const [visibleCount, setVisibleCount] = useState(300);

  // Arama metni değişince visibleCount sıfırlansın
  useEffect(() => {
    setVisibleCount(300);
  }, [iconSearch]);

  // Global form input değişikleri
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  // Modal içindeki element alanı değişiklikleri
  const handleElementChange = (e) => {
    const { name, value, type, checked } = e.target;
    setNewElement((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  // Element ekle
  const handleAddElement = () => {
    setFormData((prev) => ({
      ...prev,
      elements: [...prev.elements, newElement],
    }));
    // State'i sıfırla
    setNewElement({
      type: "text",
      name: "",
      label: "",
      placeholder: "",
      required: false,
      table: false,
      maxWidth: "",
      maxHeight: "",
      content_values: "",
      content_titles: ""
    });
    setShowElementModal(false);
  };

  // onDragEnd -> sürükle‐bırak bittiğinde çağrılır
  const onDragEnd = (result) => {
    if (!result.destination) return;
    const newOrder = reorder(
      formData.elements,
      result.source.index,
      result.destination.index
    );
    setFormData((prev) => ({ ...prev, elements: newOrder }));
  };

  // Formu kaydet
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const token = localStorage.getItem("admin_token");
      const { hasCategory, showTable, ...rest } = formData;

      const enhancedElements = formData.elements.map((el) => ({
        ...el,
        table: typeof el.table === "boolean" ? el.table : showTable,
      }));

      const catFlag   = formData.categoryType === "single" || formData.categoryType === "multiple";
      const multiFlag = formData.categoryType === "multiple";

      const payload = {
        ...rest,
        elements: JSON.stringify(enhancedElements),
        category:           catFlag   ? "1" : "0",
        multiple_category:  multiFlag ? "1" : "0",
      };

      const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/modules`, payload, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      const { data: fresh } = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/modules`, {
        headers:{ Authorization:`Bearer ${token}` }
      });
      
      // 3) Menüler bileşenine haber ver
      window.dispatchEvent(new CustomEvent("modulesUpdated", { detail: fresh }));

      console.log("Kaydedildi:", response.data);
      alert("Modül başarıyla kaydedildi!");

      // Formu sıfırla
      setFormData({
        name: "",
        icon: "",
        single_name: "",
        single_slug: "",
        multiple_name: "",
        multiple_slug: "",
        elements: [],
        showTable: false,
        hasCategory: false,
        categoryType: "none",
        
      });
    } catch (err) {
      console.error("Modül kaydedilemedi:", err);
      alert("Kaydetme başarısız!");
    } finally {
      setLoading(false);
    }
  };

  // İkon filtreleme
  const filteredIcons = icons.filter((iconName) =>
    iconName.toLowerCase().includes(iconSearch.toLowerCase())
  );

  // İkon seçilince
  const handleIconSelect = (iconName) => {
    setFormData((prev) => ({ ...prev, icon: iconName }));
    setShowIconModal(false);
  };

  return (
    <div className="container mt-4">
      <div className="card p-3 shadow-sm">

        <form onSubmit={handleSubmit}>
          {/* Ana Bilgiler */}
          <div className="row mb-3">
            <div className="col-md-6">
              <label className="form-label fw-bold">{getText("MODULE_NAME_LABEL")}</label>
              <input
                name="name"
                className="form-control"
                value={formData.name}
                onChange={handleChange}
              />
            </div>
            <div className="col-md-6">
              <label className="form-label fw-bold">{getText("MODULE_ICON_LABEL")}</label>
              <div className="input-group">
                <input
                  name="icon"
                  className="form-control"
                  value={formData.icon}
                  onChange={handleChange}
                  placeholder="örn: home.svg"
                />
                <button
                  type="button"
                  className="btn btn-outline-primary"
                  onClick={() => setShowIconModal(true)}
                >
                  {getText("ICON_SELECT_TITLE")}
                </button>
              </div>
              {formData.icon && (
                <div className="mt-2">
                  <img
                   src={`${process.env.PUBLIC_URL}/icons/svg/${formData.icon}`}
                    alt={formData.icon}
                    style={{ width: 30, height: 30 }}
                  />
                  <span className="ms-2">{formData.icon}</span>
                </div>
              )}
            </div>
          </div>

          {/* Tekil / Çoğul alanlar */}
          <div className="row mb-3">
            <div className="col-md-6">
              <label className="form-label fw-bold">{getText("MODULE_SINGLE_NAME_LABEL")}</label>
              <input
                name="single_name"
                className="form-control"
                value={formData.single_name}
                onChange={handleChange}
              />
            </div>
            <div className="col-md-6">
              <label className="form-label fw-bold">{getText("MODULE_SINGLE_SLUG_LABEL")}</label>
              <input
                name="single_slug"
                className="form-control"
                value={formData.single_slug}
                onChange={handleChange}
              />
            </div>
          </div>

          <div className="row mb-3">
            <div className="col-md-6">
              <label className="form-label fw-bold">{getText("MODULE_MULTIPLE_NAME_LABEL")}</label>
              <input
                name="multiple_name"
                className="form-control"
                value={formData.multiple_name}
                onChange={handleChange}
              />
            </div>
            <div className="col-md-6">
              <label className="form-label fw-bold">{getText("MODULE_MULTIPLE_SLUG_LABEL")}</label>
              <input
                name="multiple_slug"
                className="form-control"
                value={formData.multiple_slug}
                onChange={handleChange}
              />
            </div>
          </div>

          {/* ---- kategori tipi ---- */}
          <div className="row mb-3">
            <div className="col-md-6">
              <Form.Label className="fw-bold">{getText("MODULE_CATEGORY_TYPE_LABEL")}</Form.Label>
              <Form.Select name="categoryType" value={formData.categoryType}
                onChange={handleChange}>
                <option value="none">{getText("CATEGORY_NONE")}</option>
                <option value="single">{getText("CATEGORY_SINGLE")}</option>
                <option value="multiple">{getText("CATEGORY_MULTIPLE")
                }</option>
              </Form.Select>
            </div>
          </div>

          {/* Element Ekleme Butonu */}
          <div className="mb-3">
            <button
              type="button"
              className="btn btn-outline-primary"
              onClick={() => setShowElementModal(true)}
            >
              {getText("ADD_ELEMENT_BTN")}
            </button>
          </div>

          {/* Element Listesi (Sürükle-Bırak) */}
          {formData.elements.length > 0 && (
            <DragDropContext onDragEnd={onDragEnd}>
              <Droppable droppableId="elementsDroppable">
                {(provided) => (
                  <ul className="list-group mb-3" ref={provided.innerRef} {...provided.droppableProps}>
                    {formData.elements.map((el, idx) => (
                      <Draggable
                        key={`element-${idx}`}
                        draggableId={`element-${idx}`}
                        index={idx}
                      >
                        {(provided) => (
                          <li
                            className="list-group-item d-flex justify-content-between"
                            ref={provided.innerRef}
                            {...provided.draggableProps}
                          >
                            {/* Sol tarafta sürükleme tutacağı */}
                            <div
                              {...provided.dragHandleProps}
                              style={{ cursor: "grab", marginRight: "1rem" }}
                            >
                              <svg width="20" height="20" viewBox="0 0 100 80">
                                <rect width="100" height="10"></rect>
                                <rect y="30" width="100" height="10"></rect>
                                <rect y="60" width="100" height="10"></rect>
                              </svg>
                            </div>

                            {/* Eleman Bilgisi */}
                            <div style={{ flex: 1 }}>
                              <strong>{el.type.toUpperCase()}</strong> <em>({el.name})</em> – {el.label}
                              {el.placeholder && ` (${el.placeholder})`}
                              {el.required && <span className="ms-1 text-danger">*</span>}

                              {/* Sadece image/images tipinde maxWidth & maxHeight göster */}
                              {(el.type === "image" || el.type === "images") && (el.maxWidth || el.maxHeight) && (
                                <small className="text-muted ms-2">
                                  (Max: {el.maxWidth || "?"} x {el.maxHeight || "?"} px)
                                </small>
                              )}

                              {typeof el.table !== "undefined" && (
                                <span className="ms-2 badge bg-info">
                                  {el.table ? getText("FIELD_SHOW_TABLE") : getText("FIELD_NOT_IN_TABLE")}
                                </span>
                              )}
                            </div>
                          </li>
                        )}
                      </Draggable>
                    ))}
                    {provided.placeholder}
                  </ul>
                )}
              </Droppable>
            </DragDropContext>
          )}

          {/* Kaydet Butonu */}
          <div className="d-flex justify-content-center">
            <button type="submit" className="btn btn-primary" disabled={loading}>
            {getText("SAVE_BTN")}
            </button>
          </div>
        </form>
      </div>

      {/* Modal: Yeni Element Ekle */}
      <Modal show={showElementModal} onHide={() => setShowElementModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>{getText("MODAL_ADD_ELEMENT_TITLE")}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group className="mb-3">
            <Form.Label>{getText("ELEMENT_TYPE_LABEL")}</Form.Label>
            <Form.Select
              name="type"
              value={newElement.type}
              onChange={handleElementChange}
            >
             <option value="text">{getText("FIELD_TYPE_TEXT")}</option>
            <option value="textarea">{getText("FIELD_TYPE_TEXTAREA")}</option>
            <option value="editor">{getText("FIELD_TYPE_EDITOR")}</option>
            <option value="shortDate">{getText("FIELD_TYPE_SHORT_DATE")}</option>
            <option value="longDate">{getText("FIELD_TYPE_LONG_DATE")}</option>
            <option value="image">{getText("FIELD_TYPE_IMAGE")}</option>
            <option value="images">{getText("FIELD_TYPE_IMAGES")}</option>
            <option value="file">{getText("FIELD_TYPE_FILE")}</option>
            <option value="files">{getText("FIELD_TYPE_FILES")}</option>
            <option value="select">{getText("FIELD_TYPE_SELECT")}</option>
            <option value="multiselect">{getText("FIELD_TYPE_MULTISELECT")}</option>

            </Form.Select>
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>{getText("ELEMENT_NAME_LABEL")}</Form.Label>
            <Form.Control
              name="name"
              value={newElement.name}
              onChange={handleElementChange}
              placeholder="Örn: titleInput"
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>{getText("ELEMENT_LABEL_LABEL")}</Form.Label>
            <Form.Control
              name="label"
              value={newElement.label}
              onChange={handleElementChange}
              placeholder={getText("FIELD_LABEL_PLACEHOLDER")}
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>{getText("ELEMENT_PLACEHOLDER_LABEL")}</Form.Label>
            <Form.Control
              name="placeholder"
              value={newElement.placeholder}
              onChange={handleElementChange}
              placeholder={getText("FIELD_INPUT_PLACEHOLDER")}
            />
          </Form.Group>

          {/* Sadece "image" veya "images" seçilince boyut alanlarını göster */}
          {(newElement.type === "image" || newElement.type === "images") && (
            <>
              <Form.Group className="mb-3">
                <Form.Label>{getText("ELEMENT_MAX_WIDTH_LABEL")}</Form.Label>
                <Form.Control
                  type="number"
                  name="maxWidth"
                  value={newElement.maxWidth}
                  onChange={handleElementChange}
                  placeholder="Örn: 800"
                />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>{getText("ELEMENT_MAX_HEIGHT_LABEL")}</Form.Label>
                <Form.Control
                  type="number"
                  name="maxHeight"
                  value={newElement.maxHeight}
                  onChange={handleElementChange}
                  placeholder="Örn: 600"
                />
              </Form.Group>
            </>
          )}

          <Form.Check
            type="checkbox"
            id="requiredCheck"
            label={getText("ELEMENT_REQUIRED_LABEL")}
            name="required"
            checked={newElement.required}
            onChange={handleElementChange}
          />

          <Form.Check
            type="checkbox"
            id="tableCheck"
            label={getText("ELEMENT_TABLE_LABEL")}
            name="table"
            checked={newElement.table || false}
            onChange={handleElementChange}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowElementModal(false)}>
            {getText("CANCEL_BTN")}
          </Button>
          <Button variant="primary" onClick={handleAddElement}>
            {getText("ADD_BTN")}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Modal: İkon Seç */}
      <Modal show={showIconModal} onHide={() => setShowIconModal(false)} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>{getText("ICON_SELECT_TITLE")}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <input
            type="text"
            className="form-control mb-3"
            placeholder={getText("ICON_SEARCH_PLACEHOLDER")}
            value={iconSearch}
            onChange={(e) => setIconSearch(e.target.value)}
          />
          <div
            className="row"
            style={{ maxHeight: "400px", overflowY: "auto" }}
            onScroll={(e) => {
              const { scrollTop, scrollHeight, clientHeight } = e.target;
              if (scrollHeight - scrollTop - clientHeight < 50) {
                setVisibleCount((prev) => Math.min(prev + 30, filteredIcons.length));
              }
            }}
          >
            {filteredIcons.slice(0, visibleCount).map((iconName) => (
              <div
                key={iconName}
                className="col-3 text-center mb-3"
                style={{ cursor: "pointer" }}
                onClick={() => handleIconSelect(iconName)}
              >
                <img
                  src={`${process.env.PUBLIC_URL}/icons/svg/${iconName}`}
                  
                  alt={iconName}
                  style={{ width: 40, height: 40 }}
                />
                <div style={{ fontSize: "0.8rem", marginTop: 5 }}>{iconName}</div>
              </div>
            ))}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowIconModal(false)}>
            {getText("CLOSE_BTN")}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default ModuleCreate;
